import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="landing-cta-section">
      <div className="landing-cta-dots">
        <div className="landing-cta-dot" />
        <div className="landing-cta-dot" />
        <div className="landing-cta-dot" />
      </div>
      <h2 className="landing-cta-title">
        Ready to experience<br /><em>wearable art?</em>
      </h2>
      <p className="landing-cta-sub">
        Join SHEYOU — whether you create fashion or live for it.
      </p>
      <div className="landing-cta-buttons">
        <Link to="/browse" className="landing-btn-primary">Browse Designs</Link>
        <Link to="/listing/upload" className="landing-btn-secondary">List Your Work</Link>
      </div>
    </section>
  );
};

export default CTASection;
